import { createI18n } from "vue-i18n"
import translations from "@/translation/translations.js"
import moment from "moment"
import "moment/locale/en-gb"
import "moment/locale/de"
import { setCookie } from "@/services/utils"

const STORAGE_KEY = "appLanguage"
const SUPPORTED = ["de", "en"]

function getBrowserLanguageSync() {
  const l = (navigator.language || navigator.userLanguage || "en").slice(0, 2)
  return SUPPORTED.includes(l) ? l : "en"
}

function getCookieSync(key) {
  const match = document.cookie.match(new RegExp("(^| )" + key + "=([^;]+)"))
  return match ? decodeURIComponent(match[2]) : null
}

function getInitialLanguage() {
  const stored = getCookieSync(STORAGE_KEY)
  return stored && SUPPORTED.includes(stored) ? stored : getBrowserLanguageSync()
}

const i18n = createI18n({
  legacy: false,
  locale: getInitialLanguage(),
  fallbackLocale: "en",
  messages: translations
})

moment.locale(i18n.global.locale.value === "de" ? "de" : "en-gb")

const data = [
  { locale: "en-gb", code: "en", name: { de: "Englisch", en: "English" } },
  { locale: "de", code: "de", name: { de: "Deutsch", en: "German" } }
]

const TranslationService = {
  data,
  dataByCode: Object.fromEntries(data.map(d => [d.code, d])),

  translate(key, placeholders) {
    return i18n.global.t(key, placeholders)
  },

  translatePlural(key, count) {
    return i18n.global.tc(key, count)
  },

  async setLanguage(code) {
    if (!this.dataByCode[code]) return
    i18n.global.locale.value = code
    moment.locale(this.dataByCode[code].locale)
    await setCookie(STORAGE_KEY, code, 365)
    const htmlTag = document.documentElement
    if (htmlTag) htmlTag.setAttribute("lang", code)
    const meta = document.querySelector('[http-equiv="content-language"]')
    if (meta) meta.setAttribute("content", code)
  },

  async initialize() {},

  getLanguage() {
    return i18n.global.locale.value
  }
}

export { i18n, TranslationService }
